











































































import Vue from 'vue'
import resetForm from '@morpheus/utils/admin-vue/helpers/resetForm'
import { poolBehaviorsList } from '../services/procodes-client'
import { PoolCreateData } from '../types'
import { fetchProductsList, fetchProductById } from '@morpheus/product/admin-vue/services/products-client'
import { ProductsListData, ProductShowData } from '@morpheus/product/admin-vue/types'

export default Vue.extend({
  name: 'PoolsForm',
  props: {
    formId: {
      required: true,
      type: String
    },
    editedItem: {
      required: false,
      type: Object,
      default: () => ({})
    },
    btnLabel: {
      required: false,
      type: String,
      default: 'Submit'
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      productsList: [] as Array<ProductShowData>,
      poolBehaviorsList: poolBehaviorsList,
      pool: {
        name: '',
        product_id: '',
        behaviors: [] as Array<string>,
        available_since: '',
        available_until: ''
      },
      search: null,
      loading: false,
      availableSince: null as Date|null,
      availableUntil: null as Date|null
    }
  },
  computed: {
    showDatesForLimited (): boolean {
      return this.pool.behaviors.indexOf('limited') > -1
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clear()
      }
    },
    availableSince (val: any) {
      if (val) {
        this.pool.available_since = val.toISOString()
      } else {
        this.pool.available_since = ''
      }
    },
    availableUntil (val: any) {
      if (val) {
        this.pool.available_until = val.toISOString()
      } else {
        this.pool.available_until = ''
      }
    },
    async search (val) {
      if(val) {
        await this.querySelections(val)
      }
    }
  },
  async mounted () {
    await this.fetchSearchItems('')

    for (var prop in this.editedItem) {
      if (this.editedItem.hasOwnProperty(prop)) {
        Vue.set(this.pool, prop, this.editedItem[prop])
      }
    }

    // Check the availability of the editedItem.product_id in the products list.
    // It must be added manually
    this.setValueToAutocomplete()

    if (this.editedItem.available_since) {
      this.availableSince = new Date(this.editedItem.available_since)
    }

    if (this.editedItem.available_until) {
      this.availableUntil = new Date(this.editedItem.available_until)
    }
  },
  methods: {
    async fetchSearchItems (params: string) {
      try {
        const { items, total }: ProductsListData = await fetchProductsList(params)

        items.forEach((item: ProductShowData, index: number) => {
          Vue.set(this.productsList, index, item)
        })
      } catch (error) {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      }

      this.loading = false
    },
    async querySelections (v: string) {
      this.loading = true

      await this.fetchSearchItems(`?query=${v}`)
    },
    setValueToAutocomplete() {
      const productAvailability = this.productsList.filter((i) => i._id === this.pool.product_id)

      if(this.pool.product_id && !productAvailability.length) {
        fetchProductById(this.pool.product_id)
          .then((product: ProductShowData) => {
            this.productsList.push(product)
          })
          .catch(error => {
            this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
          })
          .finally(() => {
            this.loading = false
            this.$store.commit('global/setLoading', false)
          })
      }
    },
    submit () {
      this.$validator.validateAll()
        .then((result: any) => {
          if (result) {
            const pool: PoolCreateData = {
              name: this.pool.name,
              product_id: this.pool.product_id,
              behaviors: this.pool.behaviors
            }
            if (this.showDatesForLimited) {
              pool.available_since = this.pool.available_since
              pool.available_until = this.pool.available_until
            }
            this.$emit('onSubmit', pool)
          }
        })
    },
    clear () {
      resetForm(this.pool)
      this.$validator.reset()
      this.$emit('onClearForm')
    }
  }
})
